var map = {
	"./device/battery1_2x.png": 10203,
	"./device/battery2_2x.png": 96416,
	"./device/battery3_2x.png": 3937,
	"./device/battery4_2x.png": 64270,
	"./device/device_location.svg": 6479,
	"./device/located-gpsoff.png": 61054,
	"./device/located-gpson.png": 70070,
	"./device/lost-gpsoff.png": 47972,
	"./device/lost-gpson.png": 32534,
	"./device/phone-marker-special.png": 37987,
	"./device/phone-marker.png": 47298,
	"./event/elections.svg": 44987,
	"./event/meeting.svg": 41241,
	"./event/military.svg": 96836,
	"./event/national-date.svg": 54237,
	"./event/religious.svg": 33874,
	"./event/trial.svg": 49966,
	"./incident/unused/bomb.svg": 73589,
	"./incident/unused/criminal.svg": 34308,
	"./incident/unused/generic.svg": 16991,
	"./incident/unused/natural.svg": 57738,
	"./incident/unused/sanitary.svg": 91980,
	"./incident/unused/shooting.svg": 99737,
	"./incident/unused/social.svg": 56609,
	"./language/english.png": 607,
	"./language/french.png": 75673,
	"./poi/airport.svg": 72831,
	"./poi/embassy.svg": 80288,
	"./poi/hospital.svg": 23224,
	"./poi/police.svg": 17182,
	"./poi/station.svg": 725,
	"./site/site.png": 45769,
	"./site/thumbs_up.png": 29418
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88497;